import React, { SVGProps } from 'react';
import { css } from '@emotion/css';
import { IcoMoonSvgs, IcoMoonIconsEnum, initSvg } from './svg';

interface IcoMoonIconProps extends SVGProps<SVGSVGElement> {
  icon: IcoMoonIconsEnum;
}

const IcoMoonIcon = (props: IcoMoonIconProps) => {
  const { style, icon, className, strokeWidth, width, ...other } = props;

  const styleToClass = css({
    fill: 'currentColor',
    width: `${width || '20'}px`,
    ...style,
  });

  const svgObj = IcoMoonSvgs[icon];
  return (
    <svg
      viewBox={svgObj.viewBox || initSvg.viewBox}
      aria-hidden="true"
      className={`${styleToClass} ${icon}${className ? ` ${className}` : ''}`}
      {...other}
    >
      <g
        transform={
          `scale(${svgObj.scale || initSvg.scale}) ` +
          `rotate(${svgObj.rotate || initSvg.rotate}) ` +
          `translate(${svgObj.translate || initSvg.translate})`
        }
      >
        <path stroke="currentColor" strokeWidth={strokeWidth} d={svgObj.svg} />
      </g>
    </svg>
  );
};
export default IcoMoonIcon;
